module.exports = __webpack_public_path__ + "docs/Acretrader-General-Risk-Statement.pdf";